/*Import Estilo*/
import './App.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CookieAceite from '../../components/CookieAceite';
import CardProduto from '../../components/CardProd/index.js';

/* Import SEO */
import { SEOHelmet, generateSchema } from '../../hooks/useSEO';
import { useAnalytics } from '../../hooks/useAnalytics';

/*Import Bibliotecas*/
import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

/*Import Requisição API*/
import api from '../../api';

export default function App() {
  useAnalytics();

  const [produtosDestaque, setProdutosDestaque] = useState([]);
  const [carregandoProdutos, setCarregandoProdutos] = useState(true);
  const carrosselRef = useRef(null);

  useEffect(() => {
    const buscarProdutos = async () => {
      try {
        const response = await api.get('/listarprodutos');
        const dados = response.data.produtos || [];
        // API retorna linhas planas (uma por variação) com estoque e preco no topo
        const prods = dados
          .filter(p => Number(p.estoque) > 0)
          .slice(0, 12)
          .map(prod => ({
            ...prod,
            preco: Number(prod.preco || 0),
          }));
        setProdutosDestaque(prods);
      } catch (error) {
        console.error('Erro ao buscar produtos:', error);
      } finally {
        setCarregandoProdutos(false);
      }
    };
    buscarProdutos();
  }, []);

  const scrollCarrossel = (direcao) => {
    if (carrosselRef.current) {
      const scrollAmount = 300;
      carrosselRef.current.scrollBy({
        left: direcao === 'esquerda' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const seoData = {
    title: 'Fracaro Store - Jogos de Cama, Mesa e Banho de Qualidade',
    description: 'Compre jogos de cama, mesa e banho em renda e tecido de alta qualidade. Oferecemos produtos sofisticados para deixar sua casa ainda mais elegante. Frete grátis e condições especiais!',
    keywords: 'fracaro store, jogos de cama, mesa e banho, renda, tecido, decoração',
    url: window.location.href,
  };

  const organizationSchema = generateSchema('organization', {
    phone: '(11) 99763-6154',
    email: 'contato@fracarostore.com.br',
    facebook: 'https://facebook.com/fracarostore',
    instagram: 'https://instagram.com/fracarostore',
  });

  return (
    <section className='containerPrincipalHome'>
      <SEOHelmet {...seoData} schema={organizationSchema} />

      <Cabecalho />

      <CookieAceite />

      <main>
        <div className='faixa-1'>
          
          <div className='faixa-1-Conteudo'>
            <h1>Fracaro Store</h1>
            <h3>Vendemos artigos para casa, como tabua de passar roupas, sapateiras, panos de chão e diversas outras coisas, entre em contato para saber mais.</h3>
            <div className='bnt-Faixa-1'>
              <Link className='bnt-Contatos' to='/produtos'>
                <svg width="24" height="24" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 6H25M8.5 11.3333C8.5 12.3942 8.97411 13.4116 9.81802 14.1618C10.6619 14.9119 11.8065 15.3333 13 15.3333C14.1935 15.3333 15.3381 14.9119 16.182 14.1618C17.0259 13.4116 17.5 12.3942 17.5 11.3333M1 7.20933C1 6.11867 1 5.57467 1.228 5.084C1.456 4.59467 1.891 4.208 2.758 3.43733L3.742 2.56267C4.609 1.792 5.044 1.40533 5.5945 1.20267C6.145 1 6.76 1 7.9855 1H18.0145C19.2415 1 19.8535 1 20.4055 1.20267C20.956 1.40533 21.3895 1.792 22.258 2.56267L23.242 3.43733C24.1105 4.208 24.5425 4.59467 24.772 5.084C25 5.57467 25 6.11867 25 7.20933V19.6667C25 22.1813 25 23.4373 24.121 24.2187C23.242 25 21.829 25 19 25H7C4.171 25 2.758 25 1.879 24.2187C1 23.4373 1 22.1813 1 19.6667V7.20933Z"
                    stroke="#131C46" stroke-width="3" stroke-linecap="round" />
                </svg>
                Produtos</Link>
              <button className='bnt-WhatsApp' href='#' onClick={() => window.open('https://wa.me/5511997636154', '_blank')}><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.36132 39.1187L1.1339 39.9537L1.97086 39.7337L11.6241 37.1963C14.3712 38.6561 17.4451 39.4314 20.575 39.4314C31.0886 39.4314 39.6563 30.8637 39.6563 20.3501C39.6563 15.2495 37.6729 10.4538 34.0732 6.85366C32.3074 5.07087 30.2045 3.65728 27.887 2.69524C25.5694 1.73315 23.0835 1.2419 20.5742 1.2501C10.0609 1.25055 1.49375 9.81799 1.49375 20.3314C1.49375 23.6303 2.34289 26.837 3.93223 29.6798L1.36132 39.1187ZM12.0104 32.804L6.99793 34.1214L8.3261 29.2568L8.38487 29.0415L8.2639 28.854L7.89074 28.2756C6.39955 25.894 5.60793 23.1411 5.60625 20.3311C5.60641 12.0948 12.32 5.38135 20.5562 5.38135C24.5483 5.38135 28.3018 6.9409 31.1141 9.77127L31.1161 9.77327C32.5084 11.1588 33.6118 12.8071 34.3622 14.6224C35.1126 16.4377 35.4951 18.3839 35.4875 20.3482L35.4875 20.3523C35.5238 28.5857 28.8126 35.2813 20.575 35.2813C17.8907 35.2813 15.2602 34.556 12.9556 33.1954C12.9552 33.1951 12.9547 33.1948 12.9543 33.1946L12.3947 32.8589L12.2141 32.7505L12.0104 32.804ZM26.0706 22.2498L26.0582 22.2448L26.0455 22.2404L26.0421 22.2392C25.8435 22.1701 25.5561 22.0701 25.2588 22.1032C24.9062 22.1423 24.6371 22.3467 24.4232 22.6486L24.4232 22.6485L24.4178 22.6564C24.1183 23.0968 23.2561 24.1258 22.9925 24.4271L22.9875 24.4327L22.9828 24.4385C22.941 24.4892 22.9129 24.511 22.899 24.5198C22.8889 24.5261 22.8853 24.5265 22.8827 24.5268L22.8823 24.5269C22.8675 24.5286 22.788 24.5298 22.5869 24.4252L22.5798 24.4216L22.5726 24.4181C22.4969 24.3817 22.4005 24.3402 22.2857 24.2907C21.6371 24.011 20.3988 23.4772 18.9582 22.1898L18.9578 22.1895C17.6373 21.0117 16.7531 19.5582 16.4705 19.0875C16.4311 19.0158 16.4225 18.9754 16.4206 18.9604C16.4191 18.949 16.4203 18.9469 16.4213 18.9442C16.4239 18.9369 16.433 18.9167 16.4631 18.8789C16.4946 18.8393 16.5358 18.7964 16.5973 18.7349C16.7548 18.5774 16.9501 18.3414 17.1207 18.1354C17.192 18.0492 17.2591 17.9683 17.3171 17.9005C17.5648 17.6115 17.6862 17.3669 17.8151 17.1071C17.8278 17.0816 17.8405 17.0559 17.8535 17.03L17.8536 17.03L17.8587 17.0192C18.1004 16.5056 17.9633 16.0711 17.816 15.7765C17.7155 15.5756 16.7886 13.3159 16.408 12.3644L16.408 12.3644L16.4053 12.3578C16.1945 11.8518 15.9366 11.5275 15.6002 11.3658C15.3341 11.238 15.0217 11.2435 14.944 11.2449C14.9351 11.245 14.9293 11.2451 14.927 11.245L14.9104 11.2439H14.8938H13.9937C13.5586 11.2439 12.929 11.3988 12.3883 11.9866L12.3882 11.9865L12.3809 11.9948C12.3502 12.0297 12.3142 12.0691 12.274 12.1132C11.7803 12.6541 10.6438 13.8995 10.6438 16.2064C10.6438 17.4628 11.099 18.6697 11.5605 19.5781C12.0196 20.4819 12.507 21.1324 12.6328 21.3001C12.642 21.3133 12.6555 21.3331 12.6731 21.3588C13.116 22.0078 16.1792 26.4962 20.769 28.4772C21.897 28.9742 22.7781 29.2617 23.4628 29.4709C24.6699 29.8588 25.7667 29.7937 26.6066 29.6766L26.6097 29.6761C27.1544 29.5967 27.9115 29.2778 28.5704 28.8543C29.2157 28.4394 29.8945 27.843 30.1401 27.1356C30.3509 26.5525 30.4586 26.0091 30.4951 25.5739C30.5134 25.3565 30.5145 25.158 30.4988 24.9898C30.4854 24.8458 30.454 24.6465 30.3531 24.4879C30.2169 24.2739 30.0202 24.149 29.8521 24.0595C29.7539 24.0073 29.6259 23.9481 29.4938 23.887C29.4177 23.8518 29.3402 23.816 29.2664 23.7806C29.1606 23.7298 28.9497 23.6271 28.6838 23.4975C27.8272 23.0801 26.3992 22.3843 26.0706 22.2498Z" /></svg>WhatsApp</button>
            </div>
          </div>
        </div>

        <div className='faixa-2'>
          <div className='faixa-2-Conteudo'>
            <img src='/assets/image/pitocoFracaroStore.svg' alt='Um splitter alemão marrom, dentro de uma caixa de envios no estilo cartoon, vestindo uma camiseta estampando o nome da loja "Fracaro Store."' />
            <h3>Entregas em até 3 dias na região da capital de São Paulo e Guarulhos.</h3>
          </div>
        </div>
        <div className='faixa-3'>
          <div className='faixa-3-Conteudo'>
            <h3>Mais de 150 produtos em nosso catálogo</h3>
            <img src='/assets/image/pessoaFracaroStore.svg' alt='Uma pessoa branca com olhos azuis e cabelo castanho no estilo cartoon, vestindo uma camiseta estampando o nome da loja "Fracaro Store", examinando atentamente o catálogo da loja.' />
          </div>
        </div>
        <div className='faixa-4'>
          <div className='faixa-4-Conteudo'>
            <img src='/assets/image/zecaFracaroStore.svg' alt='Um papagaio azul no estilo cartoon, vestindo uma camiseta estampando o nome da loja "Fracaro Store", pousado de forma alegre com as asas levemente abertas.' />
            <h3>Uma empresa familiar com mais de 20 anos de experiência no mercado de vendas, com mais de 10.000 pedidos realizados.</h3>
          </div>
        </div>

        {/* Produtos em Destaque */}
        {!carregandoProdutos && produtosDestaque.length > 0 && (
          <div className='faixa-produtos'>
            <div className='faixa-produtos-conteudo'>
              <div className='faixa-produtos-header'>
                <h2>Produtos em Destaque</h2>
                <Link to='/produtos' className='ver-todos-link'>
                  Ver todos
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              </div>
              <div className='carrossel-container'>
                <button className='carrossel-btn carrossel-btn-esq' onClick={() => scrollCarrossel('esquerda')} aria-label='Rolar para esquerda'>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>
                <div className='carrossel-produtos' ref={carrosselRef}>
                  {produtosDestaque.map((prod, index) => (
                    <div
                      className='carrossel-item'
                      key={`${prod.id || prod.id_produto || 'prod'}-${prod.id_variacao || index}`}
                    >
                      <CardProduto prod={prod} />
                    </div>
                  ))}
                </div>
                <button className='carrossel-btn carrossel-btn-dir' onClick={() => scrollCarrossel('direita')} aria-label='Rolar para direita'>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>
              </div>
            </div>
          </div>
        )}
      </main>

      <Rodape />

    </section>
  );
}
